import { XMarkIcon } from "@heroicons/react/20/solid";
import { ModalConfig, useModalStore } from "@/stores/use-modal-store";

// The video in-depth view is always rendered on a fixed dark background regardless of the app
// theme, so this modal matches that instead of the theme-aware daisyUI modal-box.
export const VIDEO_SCENES_EXPLAINED_MODAL_CONFIG: ModalConfig = { className: "w-full max-w-[600px]" };

/**
 * VideoScenesExplainedModal component
 *
 * Explains how scenes are automatically detected and scored.
 */
export const VideoScenesExplainedModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-4 -m-6 p-6 rounded-2xl bg-[#1d232a]">
      {/* Header */}
      <div className="flex items-center gap-1">
        <h2 className="flex-1 text-white font-semibold text-lg">About scenes</h2>
        <button type="button" onClick={close} aria-label="Close" className="cursor-pointer">
          <XMarkIcon className="size-5 text-white" />
        </button>
      </div>

      <div className="flex flex-col gap-4 text-white/70 text-sm">
        <p>
          Our algorithm analyses your video and splits it into scenes - points where the pace, lighting, message, or storytelling angle meaningfully changes.
          For each scene we capture a description, the key elements on screen, and its duration and timestamp, then score it on Attention and the underlying
          sub-metrics.
        </p>
        <p>
          Scene divisions are automatically detected and won&apos;t always match how you&apos;d cut the video for production. If a split looks wrong, let us
          know at{" "}
          <a href="mailto:support@dragonflyai.co" className="underline">
            support@dragonflyai.co
          </a>
        </p>
      </div>
    </div>
  );
};
